export const name = 'paidPlansWixCodeSdk' as const
export const namespace = 'paid-plans' as const
